import ProductFds from './ProductFds'

export default ProductFds



// WEBPACK FOOTER //
// ./src/containers/ProductFds/index.js